import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import AddBoatMasterTimeSlot from './AddBoatMasterTimeSlot'
class BoatMasterTimeSlotAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.boat_timeslot_id !== undefined &&
      this.props.match.params.boat_timeslot_id !== null &&
      this.props.match.params.boat_timeslot_id !== 0 &&
      this.props.match.params.boat_timeslot_id !== ''
    ) {
      this.setState({ boat_timeslot_id: this.props.match.params.boat_timeslot_id })
    }
    this.getLanguageList()
  }
  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      {this.props?.match?.params?.boatType} TimeSlot
                      {this.props.match.params.boat_timeslot_id ? 'Edit' : 'Add'}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link
                        to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/boat-timeslot-lists`}
                      >
                        {this.props.match.params.boatType}TimeSlot List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.boat_timeslot_id ? 'Edit' : 'Add'}
                      TimeSlot
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'Products_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.boat_timeslot_id !== undefined &&
                        this.state.boat_timeslot_id !== null &&
                        this.state.boat_timeslot_id !== 0 &&
                        this.state.boat_timeslot_id !== '' ? (
                          <AddBoatMasterTimeSlot
                            goBack={this.props.history.goBack}
                            boatType={this.props.match.params.boatType}
                            boatId={this.props.match.params.boatId}
                            boat_timeslot_id={this.state.boat_timeslot_id}
                          />
                        ) : (
                          <AddBoatMasterTimeSlot
                            language_id={this.state.language_id}
                            boatId={this.props.match.params.boatId}
                            boatType={this.props.match.params.boatType}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatMasterTimeSlotAddTab
